import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./CaseStudies.css";

import finflowImg from "../../assets/case-study-finflow.jpg";
import omnicloudImg from "../../assets/case-study-omnicloud.jpg";
import luxeauraImg from "../../assets/case-study-luxeaura.jpg";

const projects = [
  {
    id: 1,
    title: "FinFlow Enterprise Portal",
    client: "Fintech & WealthTech",
    category: "Web Engineering & UI/UX",
    metric: "+310%",
    metricLabel: "Lead Conversion Surge",
    desc: "Redesigned complete customer onboarding journey, reducing drop-off by 54% and scaling organic inbound demos.",
    image: finflowImg,
    accentColor: "#d946ef",
    tags: ["React & Next.js", "Design System", "Conversion Optimization"],
  },
  {
    id: 2,
    title: "OmniCloud SaaS Growth Engine",
    client: "B2B Cloud Computing",
    category: "Technical SEO & Inbound Strategy",
    metric: "+240%",
    metricLabel: "Organic Search Traffic",
    desc: "Complete technical SEO overhaul, schema restructure, and programmatically generated comparison landing pages.",
    image: omnicloudImg,
    accentColor: "#00d2ff",
    tags: ["Technical SEO", "High-Volume Keywords", "Core Web Vitals"],
  },
  {
    id: 3,
    title: "LuxeAura Omnichannel Scale",
    client: "DTC Lifestyle Brand",
    category: "Paid Ads & Performance ROAS",
    metric: "6.2x",
    metricLabel: "Average Return on Ad Spend",
    desc: "Multi-channel PPC & Meta campaign scaling with dynamic creative testing and high-intent audience segmentation.",
    image: luxeauraImg,
    accentColor: "#c084fc",
    tags: ["Google Ads", "Meta Ads", "Retargeting Funnels"],
  },
];

const CaseStudies = () => {
  const navigate = useNavigate();

  return (
    <section className="case-studies-section" aria-label="Featured case studies">
      <div className="case-studies-wrap">
        <motion.div
          className="case-studies-head"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="case-studies-kicker">Proven Track Record</span>
          <h2>Featured Case Studies &amp; Growth Results</h2>
          <p>
            Explore how our strategic design, technical execution, and digital
            marketing drive compounding revenue for our partners.
          </p>
        </motion.div>

        <div className="case-studies-grid">
          {projects.map((project, idx) => (
            <motion.div
              key={project.id}
              className="case-study-card"
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
            >
              {/* Visual Mockup Header */}
              <div className="case-study-visual">
                <img
                  src={project.image}
                  alt={project.title}
                  className="case-study-img"
                  loading="lazy"
                />
                <div className="visual-overlay" />
                <div className="visual-badge">
                  <span className="visual-dot" style={{ background: project.accentColor }} />
                  {project.client}
                </div>

                <div className="visual-metric-box">
                  <div className="vm-value" style={{ color: project.accentColor }}>
                    {project.metric}
                  </div>
                  <div className="vm-label">{project.metricLabel}</div>
                </div>
              </div>

              {/* Card Body */}
              <div className="case-study-body">
                <span className="case-study-cat">{project.category}</span>
                <h3 className="case-study-title">{project.title}</h3>
                <p className="case-study-desc">{project.desc}</p>

                <div className="case-study-tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="tag-pill">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="case-study-footer">
                  <button
                    className="case-study-btn"
                    onClick={() => navigate("/contact")}
                  >
                    <span>View Project Blueprint</span>
                    <FaArrowRight className="cs-arrow" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
